import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

import { Container, Video } from './styles';

function VideoPlayer({ location: { search } }) {
  const { url, Signature, 'Key-Pair-Id': KeyPairId } = qs.parse(search, { ignoreQueryPrefix: true });
  const src = `${url}&Signature=${Signature}&Key-Pair-Id=${KeyPairId}`;

  if (!url) {
    return (
      <Container style={{ background: '#FFF' }}>
        <p>No video URL provided.</p>
      </Container>
    );
  }

  return (
    <Container>
      <Video controls controlsList="nodownload" playsinline src={src} />
    </Container>
  );
}

VideoPlayer.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export default VideoPlayer;
